import React, { useEffect, useState, useRef } from "react";
import { getContent } from "../middleware/contentFetch";

const Hero = () => {
  const [content, setContent] = useState([]);
  const [current, setCurrent] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    getContent()
      .then(data => setContent(data.hero || []))
      .catch(() => setContent([]));
  }, []);

  const next = () => {
    if (!content.length || isAnimating) return;
    setIsAnimating(true);
    setCurrent((prev) => (prev + 1) % content.length);
  };

  const prev = () => {
    if (!content.length || isAnimating) return;
    setIsAnimating(true);
    setCurrent((prev) =>
      prev === 0 ? content.length - 1 : (prev - 1)
    );
  };

  useEffect(() => {
    const timer = setTimeout(() => setIsAnimating(false), 100);
    return () => clearTimeout(timer);
  }, [current])

  // Auto swipe
  useEffect(() => {
    if (content.length === 0) return;

    const autoSlide = setInterval(() => {
      setCurrent(prev => (prev + 1) % content.length);
    }, 10000);

    return () => clearInterval(autoSlide);
  }, [content.length]);

  // Touch swipe
  const startX = useRef(0);

  const handleTouchStart = (e) => {
    startX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = (e) => {
    const endX = e.changedTouches[0].clientX;
    const diff = startX.current - endX;

    if (diff > 50) next();      // swipe left
    if (diff < -50) prev();    // swipe right
  };


  return (
    <div className="hero-carousel"
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}>
      <div
        className="hero-track"
        style={{ transform: `translateX(-${current * 100}vw)` }}
      >
        {content.map((slide) => (
          <div
            key={slide.id}
            className="hero-slide"
            style={{ backgroundImage: `url(${slide.image})` }}
          >
            <div className="overlay" />
            <div className="content">
              <h1 className="display-4 fw-bold text-white">
                {slide.title}
              </h1>
              <p className="lead text-white mb-4">
                {slide.description}
              </p>
              <div className="d-flex gap-3 justify-content-center">
                <a href={`${slide.button1.redirect}`} className={`btn ${slide.button1.class} btn-lg`}>{slide.button1.text}</a>

                <a href={`${slide.button2.redirect}`} className={`btn ${slide.button2.class} btn-lg`}>{slide.button2.text}</a>
              </div>
            </div>
          </div>
        ))}
      </div>

      <button className="control prev" onClick={prev}>‹</button>
      <button className="control next" onClick={next}>›</button>
    </div>
  );
};

export default Hero;
